// @ts-nocheck
import {useMutation} from "@tanstack/react-query";
import {updateUser} from "../services/account/account.service";

const useUpdateProfile = onSuccess => {
  const {
    data,
    isError,
    isPending,
    error,
    mutate: postUpdate,
    isSuccess,
  } = useMutation({
    mutationKey: ["update-profile"],
    mutationFn: updateUser,
    onSuccess,
    onError: _error => {},
  });

  return {
    postUpdate,
    data,
    isError,
    isPending,
    isSuccess,
    error,
  };
};

export default useUpdateProfile;
